import { render, staticRenderFns } from "./RegisterPageDesktopLogo.vue?vue&type=template&id=ed3acf84&"
import script from "./RegisterPageDesktopLogo.vue?vue&type=script&lang=js&"
export * from "./RegisterPageDesktopLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports